import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";
import { textBodyVariants } from "@/components/ui/text";
import { cn } from "@repo/common/utils/cn";
const labelVariants = cva(["leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70" // #TODO Peer disabled is not working
]);
const Label = t0 => {
  const $ = _c(12);
  let className;
  let props;
  let size;
  let weight;
  if ($[0] !== t0) {
    ({
      className,
      weight,
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
    $[4] = weight;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
    weight = $[4];
  }
  let t1;
  if ($[5] !== className || $[6] !== size || $[7] !== weight) {
    t1 = cn(textBodyVariants({
      weight,
      size,
      className
    }), labelVariants());
    $[5] = className;
    $[6] = size;
    $[7] = weight;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== props || $[10] !== t1) {
    t2 = <LabelPrimitive.Root data-slot="label" className={t1} {...props} />;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
Label.displayName = LabelPrimitive.Root.displayName;
export { Label };